import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { SpinnerService } from 'src/app/shared/loading-spinner/spinner.service';

// Requests carrying this header opt out of the global page spinner
export const SKIP_SPINNER_HEADER = 'X-Skip-Spinner';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {

  private activeRequests: number = 0;

    constructor(private spinnerService: SpinnerService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.headers.has(SKIP_SPINNER_HEADER)) {
            const cleanedReq = req.clone({ headers: req.headers.delete(SKIP_SPINNER_HEADER) });
            return next.handle(cleanedReq);
        }

        const postEndpointsToShowSpinner = [
            '/users/get-user-profile-roles',
            '/devices/get-filtered-device/all',
            '/jobs/job-list-configuration'
        ];

        const shouldShowSpinner = req.method === 'GET' ||
            (req.method === 'POST' && postEndpointsToShowSpinner.some(endpoint => req.url.includes(endpoint)));
        if (shouldShowSpinner) {
            if (this.activeRequests === 0) {
                this.spinnerService.show();
            }
            this.activeRequests++;
        }

        return next.handle(req).pipe(
            tap({
                next: (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse && shouldShowSpinner) {
                        this.decreaseRequestCount();
                    }
                },
                error: (error: HttpErrorResponse) => {
                    if (shouldShowSpinner) {
                        this.decreaseRequestCount();
                    }
                }
            })
        );
    }

    private decreaseRequestCount(): void {
        this.activeRequests--;
        if (this.activeRequests === 0) {
            this.spinnerService.hide();
        }
    }
}

